var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as qs from 'qs';
import dictionary from "dict/static.json";
import { Pagination } from "../models/pagination.model";
var DoReload = /** @class */ (function () {
    function DoReload() {
        this.total = true;
        this.chart = true;
        this.pagination = true;
        this.stats = true;
    }
    DoReload.prototype.reset = function () {
        this.total = true;
        this.chart = true;
        this.pagination = true;
        this.stats = true;
    };
    DoReload.prototype.onlyStats = function () {
        this.total = false;
        this.chart = false;
        this.pagination = false;
        this.stats = true;
    };
    return DoReload;
}());
var BaseComponent = /** @class */ (function () {
    function BaseComponent(eventsService, service, activatedRoute, filter, translate) {
        this.eventsService = eventsService;
        this.service = service;
        this.activatedRoute = activatedRoute;
        this.filter = filter;
        this.translate = translate;
        this.addFilterParams = {};
        this.isLoad = true;
        // UPDATE Бережнов Времено добавляю BaseComponent такие поля, поскольку они часто встречаются.
        // Временно, потому что нужно придумать нормально именование
        this.statsLoader = false;
        this.stats = [];
        this.currencyList = dictionary.currencyList;
        this.locations = dictionary.locations;
        this.countriesMap = dictionary.locations.reduce(function (countriesMap, country) {
            countriesMap[country.ccode] = country.caption;
            return countriesMap;
        }, {});
        this.localesMap = {};
        this.emailList = Object.keys(dictionary.emailList);
        this.links = [];
        this.totalLoader = false;
        this.paginationLoader = false;
        this.isPaginationReload = false;
        this.dontLoad = {};
        this.doReload = new DoReload();
        this.pagination = new Pagination();
        this.totalsLoader = false;
        var me = this;
        this.localesMap = Object.keys(dictionary.localesMap).reduce(function (obj, key) {
            obj[key] = dictionary.localesMap[key];
            return obj;
        }, {
            'all': me.__a('common.any'),
            'not_ru': 'not_ru'
        });
    }
    BaseComponent.prototype.ngOnInit = function () {
        var _this = this;
        // Передать addFilterParams в filterService и подписать там внутри на обновление queryParams
        this.filter.setAddFilterParams(this.addFilterParams);
        this.activatedRoute.queryParams.subscribe(function () {
            _this.filter.setReportGUID();
            _this.eventsService.broadcast('filter-apply', _this.filter.filterParams);
            _this.getData();
        });
    };
    BaseComponent.prototype.ngOnDestroy = function () {
        this.eventsService.broadcast('compoment-destroy');
    };
    BaseComponent.prototype.getData = function () {
        return __awaiter(this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/];
        }); });
    };
    BaseComponent.prototype.updateData = function (filter, type) { };
    BaseComponent.prototype.__a = function (str) {
        var params = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            params[_i - 1] = arguments[_i];
        }
        return this.translate.__A(str, params);
    };
    // TODO запилить сюда новый сервис роутинга, скрывающий работу с применением фильтра в урл
    BaseComponent.prototype.onPageChange = function (page) {
        if (page === void 0) { page = 1; }
    };
    BaseComponent.prototype.updateLinks = function (reportUrl) {
        var me = this;
        me.links = me.pagination.items.map(function (page, i) {
            var fp = me.filter.getCopyFilterParams({ 'page': i + 1 });
            return reportUrl + "?" + qs.stringify(me.filter.getApplyFilters(fp), { encode: false });
        });
    };
    return BaseComponent;
}());
export { BaseComponent };
